import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import classnames from 'classnames';

import {
  TOUR_CANCEL_REASON_REMOVED_LAST_SHOWING,
  TOUR_CANCEL_REASON_SAVED_FOR_LATER,
} from 'common/tourConstants';

import isUserAgentMobileApp from 'common/util/isUserAgentMobileApp';

import { Tour } from 'client/actions';
import branch from 'client/core/branch';

@branch({
  userAgent: ['analytics', 'userAgent'],
})
class SrTourListRowEditModal extends Component {
  static propTypes = {
    tourId: PropTypes.number.isRequired,
    listing: PropTypes.object.isRequired,
    listingDisplayText: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    userAgent: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this._onRemoveHome = this._onRemoveHome.bind(this);
    this._onSaveShowingForLater = this._onSaveShowingForLater.bind(this);
  }

  async _onRemoveHome() {
    const { tourId, listing, onClose, dispatch } = this.props;

    await dispatch(Tour.deleteShowing, {
      tourId,
      listingId: listing.id,
      tourCancelReason: TOUR_CANCEL_REASON_REMOVED_LAST_SHOWING,
      onSuccess: onClose,
    });
  }

  async _onSaveShowingForLater() {
    const { tourId, listing, onClose, dispatch } = this.props;

    await dispatch(Tour.saveShowingForLater, {
      tourId,
      listing,
      tourCancelReason: TOUR_CANCEL_REASON_SAVED_FOR_LATER,
      onSuccess: onClose,
    });
  }

  render() {
    const { isOpen, onClose, listingDisplayText, userAgent } = this.props;

    if (!isOpen) {
      return null;
    }

    const isMobileApp = isUserAgentMobileApp(userAgent);

    return (
      <Portal>
        <div
          onClick={onClose}
          className={classnames('darkModal', 'darkNavigator', { webview: isMobileApp })}
        >
          <div className="choiceContainer">
            <div className="choiceGroup">
              <div className="topLabel">
                <span>{listingDisplayText}</span>
              </div>

              <div className="choice" onClick={this._onSaveShowingForLater}>
                <span>Save for later</span>
              </div>

              <div className="choice red" onClick={this._onRemoveHome}>
                <span>Remove home</span>
              </div>
            </div>

            <div className="choice solo" onClick={onClose}>
              <span>Cancel</span>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrTourListRowEditModal.displayName = 'SrTourListRowEditModal';

export default SrTourListRowEditModal;
